import { Component, inject, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog } from '@angular/material/dialog';
import { SicotService } from '../sicot.service';
import { Distretto } from '../types/Distretto';
import { DistrettoDialogComponent } from './distretto-dialog/distretto-dialog.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-admin-distretti',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    HeaderComponent,
    FooterComponent,
    MatCardModule,
    MatTableModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatIconModule,
  ],
  templateUrl: './admin-distretti.component.html',
  styleUrl: './admin-distretti.component.css',
})
export class AdminDistrettiComponent implements OnInit {
  private readonly sicotService = inject(SicotService);
  private readonly dialog = inject(MatDialog);

  distretti: Distretto[] = [];
  caricamento = true;
  errore: string | null = null;
  displayedColumns: string[] = ['codice', 'descrizione', 'actions'];

  ngOnInit(): void {
    this.loadList();
  }

  loadList(): void {
    this.caricamento = true;
    this.errore = null;
    this.sicotService.getDistretti().subscribe({
      next: (list) => {
        this.distretti = list ?? [];
        this.caricamento = false;
      },
      error: () => {
        this.errore = 'Errore nel caricamento dei distretti.';
        this.caricamento = false;
      },
    });
  }

  aggiungi(): void {
    const ref = this.dialog.open(DistrettoDialogComponent, {
      data: { distretto: null },
      width: '420px',
    });
    ref.afterClosed().subscribe((result) => {
      if (result) this.loadList();
    });
  }

  modifica(d: Distretto): void {
    const ref = this.dialog.open(DistrettoDialogComponent, {
      data: { distretto: d },
      width: '420px',
    });
    ref.afterClosed().subscribe((result) => {
      if (result) this.loadList();
    });
  }

  elimina(d: Distretto): void {
    if (!confirm(`Eliminare il distretto "${d.descrizione}" (codice ${d.codice})?`)) return;
    this.sicotService.deleteDistretto(d.codice).subscribe({
      next: () => this.loadList(),
      error: () => {
        this.errore = 'Errore durante l\'eliminazione del distretto.';
      },
    });
  }
}
